import { Color } from 'src/api/misc/Color'
import {
  types,
  IModelType,
  Instance,
  ModelProperties,
  ISimpleType,
  IOptionalIType,
  resolvePath,
  tryResolve
} from 'mobx-state-tree'
import { generateNodeType } from 'src/api/models/utils/generateNodeType'
import { IPerceptionOther, IPerceptionProps } from './types'
import { Typename } from 'src/constants/typenames'
import { RouteState } from 'src/constants/routes'

/**
 *
 * Printedcircuitboard
 * AdapterPlate
 * CoverPlate
 * Screw
 * Nut
 * Feet
 * Bracket
 */

// export const generateGroupPerception = (visible = true) =>
//   types
//     .model()
//     .volatile(self => ({ visible: visible }))
//     .actions(self => ({
//       setVisible(nextVisible: boolean) {
//         self.visible = nextVisible
//       }
//     }))

// const generatePerceptionBase = (config?: IPerceptionBaseConfiguration): IPerceptionBase =>
//   types
//     .model()
//     .volatile(self => ({
//       visible: config?.visible || true,
//       opacity: config?.opacity || (1 as number)
//     }))
//     .actions(self => ({
//       setOpacity(opactiy: number) {
//         self.opacity
//       },
//       hide() {
//         self.visible = false
//       },
//       show() {
//         self.visible = true
//       },
//       resetPerception() {
//         self.visible = config?.visible || true
//         self.opacity = config?.opacity || (1 as number)
//       }
//     }))

// export const generatePerception = (config?: IPerceptionConfiguration): IPerception =>
//   generatePerceptionBase().volatile(self => ({
//     fill: generatePerceptionBase(config?.fill || config).create(),
//     line: generatePerceptionBase(config?.line || config).create()
//   }))

export const withPerception = <
  PA extends { __typename: IOptionalIType<ISimpleType<Typename>, [undefined]> },
  OA extends { routeState: RouteState },
  FCA,
  FSA
>(
  model: IModelType<PA, OA, FCA, FSA>
): IModelType<PA, OA & IPerceptionOther, FCA, FSA> =>
  model.views(self => ({
    get perception() {
      if (self.routeState.view?.perceptions?.has(self.__typename)) {
        const perception = self.routeState.view?.perceptions?.get(self.__typename)
        if (perception.selector) {
          let selectorValue
          if (perception.selector.search(/\//g) !== -1) {
            selectorValue = tryResolve(self, perception.selector)
          } else if (perception.selector.search(/\./g) !== -1) {
          } else {
            selectorValue = self[perception.selector as keyof typeof self]
          }
          self.__typename === 'GapSide' &&
            console.log(self.__typename, perception.selector, selectorValue, self)
          return perception[selectorValue] || undefined
        } else {
          return perception
        }
      }
      return undefined
    }
    // get opacity() {
    //   // if (self.routeState.perceptions?.[self.__typename]) {
    //   //   self.routeState.perceptions?.[self.__typename].selector?.(self)
    //   // }
    //   return self.routeState.perceptions?.[self.__typename]?.opacity
    // },
    // get visible() {
    //   self.__typename === 'Cover' && console.log(self.routeState)
    //   return self.routeState.perceptions?.[self.__typename]?.visible
    // }
  }))
// .actions(self => ({
//   afterAttach() {
//     self.perception && console.log(self.__typename, self.perception)
//   }
// }))
